import React from 'react'

import { exportarImagemDashSimcards } from '../exportarImagem'

export default function ExportarImagem(props) {
  return (
    <li>
      <div className="drop-acoes-menu item-drop-acoes-hover">
        <span
          className="drop-acoes-menu-label fonte-cor-1"
          onClick={() => exportarImagemDashSimcards(props.exportar)}
        >
          Exportar imagem
        </span>
      </div>
    </li>
  )
}
